import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { option_type, string_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, getCsrfEnabledRequest, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { SendSMSDTO$reflection } from "./Model.js";
import { Http_send, Http_request, Http_method, Http_content, Http_withCredentials } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, BodyContent } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";

export function sendSms(clientNr, invoiceeNr, data) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Invoicee/SendSMS/%i/%i"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(SendSMSDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(data));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

